"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.standardProviderFactory = exports.batchingProviderFactory = exports.StandardProviderFactory = exports.ProviderFactory = exports.BatchingProviderFactory = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _StaticJsonRpcBatchProvider = require("./StaticJsonRpcBatchProvider");
var _ethcall = require("@blockwell/ethcall");
var _websocket = require("./websocket");
var _Metrics = require("./Metrics");
var _RpcProvider = require("./RpcProvider");
var _ExtProvider = require("./ExtProvider");
class ProviderFactory {
  constructor() {
    (0, _defineProperty2.default)(this, "providerCache", {});
    (0, _defineProperty2.default)(this, "wsCache", {});
    (0, _defineProperty2.default)(this, "metrics", {});
  }
  async getProvider(input) {
    if ("decimals" in input) {
      return (await this.getEthcallProvider(input)).provider;
    }
    return new _ExtProvider.ExtProvider(input);
  }
  async getEthcallProvider(input) {
    let ws = this.wsCache[input.chainId];
    // Use websocket if it's available
    if (ws) {
      if (!ws.ethcall) {
        ws.ethcall = new _ethcall.EthcallProvider();
        ws.ethcall.initChain(ws.provider, input.chainId);
      }
      return ws;
    }
    let cached = this.providerCache[input.chainId];
    if (!cached) {
      let provider = this.providerForChain(input);
      let ethcall;
      if (provider) {
        ethcall = new _ethcall.EthcallProvider();
        await ethcall.init(provider);

        // If another thread already added it
        if (this.providerCache[input.chainId]) {
          return this.providerCache[input.chainId];
        }
      }
      cached = {
        provider,
        ethcall
      };
      this.providerCache[input.chainId] = cached;
    }
    return cached;
  }
  websocketForChain(input) {
    var _cached;
    let cached = this.wsCache[input.chainId];
    if (cached === undefined) {
      let url = input.getWsUrl();
      if (url) {
        let provider = new _websocket.ReconnectingWebSocketProvider(url, input.chainId);
        let metrics = (0, _Metrics.presetLabels)({
          chainId: input.chainId
        }, this.metrics);
        provider.on("debug", event => {
          var _metrics$wsOpen, _metrics$wsClose, _metrics$wsKeepalive, _metrics$wsReconnect, _metrics$requests;
          switch (event.action) {
            case "open":
              (_metrics$wsOpen = metrics.wsOpen) === null || _metrics$wsOpen === void 0 ? void 0 : _metrics$wsOpen.inc();
              break;
            case "close":
              (_metrics$wsClose = metrics.wsClose) === null || _metrics$wsClose === void 0 ? void 0 : _metrics$wsClose.inc();
              break;
            case "keepalive":
              (_metrics$wsKeepalive = metrics.wsKeepalive) === null || _metrics$wsKeepalive === void 0 ? void 0 : _metrics$wsKeepalive.inc();
              break;
            case "reconnect":
              (_metrics$wsReconnect = metrics.wsReconnect) === null || _metrics$wsReconnect === void 0 ? void 0 : _metrics$wsReconnect.inc();
              break;
            case "request":
              (_metrics$requests = metrics.requests) === null || _metrics$requests === void 0 ? void 0 : _metrics$requests.inc();
              break;
          }
        });
        cached = {
          provider
        };
      } else {
        cached = null;
      }
      this.wsCache[input.chainId] = cached;
    }
    return (_cached = cached) === null || _cached === void 0 ? void 0 : _cached.provider;
  }
  close(input) {
    let cached = this.wsCache[input.chainId];
    if (cached) {
      delete this.wsCache[input.chainId];
      // Allow some time for code that already has a reference to this provider
      // to make its requests.
      setTimeout(() => {
        var _cached$provider, _cached$provider$webs;
        (_cached$provider = cached.provider) === null || _cached$provider === void 0 ? void 0 : (_cached$provider$webs = _cached$provider.websocket) === null || _cached$provider$webs === void 0 ? void 0 : _cached$provider$webs.close(1000);

        // Delay removing listeners so we can record metrics for close
        setTimeout(() => {
          var _cached$provider2;
          (_cached$provider2 = cached.provider) === null || _cached$provider2 === void 0 ? void 0 : _cached$provider2.removeAllListeners();
        }, 2000);
      }, 2000);
    } else {
      let cached = this.providerCache[input.chainId];
      if (cached !== null && cached !== void 0 && cached.provider) {
        var _cached$provider3;
        cached.provider.polling = false;
        (_cached$provider3 = cached.provider) === null || _cached$provider3 === void 0 ? void 0 : _cached$provider3.removeAllListeners();
      }
    }
  }
  closeAll() {
    for (let val of Object.values(this.wsCache)) {
      var _val$provider, _val$provider$websock, _val$provider2;
      (_val$provider = val.provider) === null || _val$provider === void 0 ? void 0 : (_val$provider$websock = _val$provider.websocket) === null || _val$provider$websock === void 0 ? void 0 : _val$provider$websock.close(1000);
      (_val$provider2 = val.provider) === null || _val$provider2 === void 0 ? void 0 : _val$provider2.removeAllListeners();
    }
    this.wsCache = {};
    for (let val of Object.values(this.providerCache)) {
      if (val !== null && val !== void 0 && val.provider) {
        var _val$provider3;
        val.provider.polling = false;
        (_val$provider3 = val.provider) === null || _val$provider3 === void 0 ? void 0 : _val$provider3.removeAllListeners();
      }
    }
    this.providerCache = {};
  }
}
exports.ProviderFactory = ProviderFactory;
class StandardProviderFactory extends ProviderFactory {
  providerForChain(input) {
    let url = input.getNodeUrl();
    if (url) {
      let provider = new _RpcProvider.RpcProvider(input.getNodeUrl(), input.chainId);
      let metrics = (0, _Metrics.presetLabels)({
        chainId: input.chainId
      }, this.metrics);
      provider.on("debug", event => {
        var _metrics$requests2;
        switch (event.action) {
          case "request":
            (_metrics$requests2 = metrics.requests) === null || _metrics$requests2 === void 0 ? void 0 : _metrics$requests2.inc();
            break;
        }
      });
      return provider;
    }
    return null;
  }
}
exports.StandardProviderFactory = StandardProviderFactory;
class BatchingProviderFactory extends ProviderFactory {
  providerForChain(input) {
    let url = input.getNodeUrl();
    if (url) {
      let provider = new _StaticJsonRpcBatchProvider.StaticJsonRpcBatchProvider(input.getNodeUrl(), input.chainId);
      let metrics = (0, _Metrics.presetLabels)({
        chainId: input.chainId
      }, this.metrics);
      provider.on("debug", event => {
        var _metrics$rpcBatches, _metrics$rpcBatchRequ, _event$request, _metrics$requests3, _event$request2;
        switch (event.action) {
          case "requestBatch":
            (_metrics$rpcBatches = metrics.rpcBatches) === null || _metrics$rpcBatches === void 0 ? void 0 : _metrics$rpcBatches.inc();
            (_metrics$rpcBatchRequ = metrics.rpcBatchRequests) === null || _metrics$rpcBatchRequ === void 0 ? void 0 : _metrics$rpcBatchRequ.inc((_event$request = event.request) === null || _event$request === void 0 ? void 0 : _event$request.length);
            (_metrics$requests3 = metrics.requests) === null || _metrics$requests3 === void 0 ? void 0 : _metrics$requests3.inc((_event$request2 = event.request) === null || _event$request2 === void 0 ? void 0 : _event$request2.length);
            break;
        }
      });
      return provider;
    }
    return null;
  }
}
exports.BatchingProviderFactory = BatchingProviderFactory;
const standardProviderFactory = exports.standardProviderFactory = new StandardProviderFactory();
const batchingProviderFactory = exports.batchingProviderFactory = new BatchingProviderFactory();
//# sourceMappingURL=ProviderFactory.js.map